import React, { Fragment } from 'react'
import CustomTable from '../../../../../elements/Table/CustomTable'
import MoneyCell from '../../../../../elements/Table/Cells/MoneyCell'
import { Link } from 'react-router-dom'
import { MODAL_TYPE_EDIT } from '../../../../../elements/Hooks/useModalData'
import { Button, Popconfirm } from 'antd'

PayrollClaimsLines.propTypes = {}

function PayrollClaimsLines(props) {
  const { fetch, fetching, payrollClaim, onShow, onShowCSV, onSendPayClaim } = props
  const columns = [
    {
      Header: 'SystemID',
      accessor: '_key',
      Cell: ({ value, original }) => (
        <Link onClick={() => onShow(original, MODAL_TYPE_EDIT)}>{value}</Link>
      ),
    },

    { accessor: 'employee.fn', Header: 'Employee' },
    { Header: 'Bank', accessor: 'bank.bank.name' },
    { Header: 'Account Number', accessor: 'bank.number' },
    { accessor: 'amount', Header: 'Amount', Cell: MoneyCell },
  ]

  return (
    <CustomTable
      columns={columns}
      data={payrollClaim.lines}
      fetch={fetch}
      fetching={fetching}
      defaultPageSize={20}
      CreateButton={() => (
        <Fragment>
          <Button type="dashed" onClick={onShowCSV} disabled={payrollClaim.status !== 'Approved'}>
            {'Generate CSV'}
          </Button>
          <Popconfirm
            title="Are you sure you want to send pay Slip?"
            onConfirm={onSendPayClaim}
            okText="Yes"
            cancelText="No">
            <Button
              type="dashed"
              style={{ marginLeft: '5px' }}
              disabled={payrollClaim.status !== 'Paid'}>
              {'Send Payroll Claim'}
            </Button>
          </Popconfirm>
        </Fragment>
      )}
    />
  )
}

export default PayrollClaimsLines
